import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
    HolidayModel,
    HolidayUpdateModel,
    HolidayInsertModel,
    HolidayDeleteModel,
} from '../interfaces/holiday-data';

@Injectable({
    providedIn: 'root',
})
export class HolidayService extends BehaviorSubject<any[]> {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/holidayhours/').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {
        super([]);
    }

    getHolidays(clientShortName: string): Observable<HolidayModel[]> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<HolidayModel[]>(this._url + 'GetHolidays', {
            params: params,
        });
    }

    updateHoliday(model: HolidayModel): Observable<any> {
        var upModel = this.convertHolidayModelToHolidayUpdateModel(model);
        let formattedModel: JSON = this.formatUpdateModel(upModel);
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'UpdateHoliday', formattedModel).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    insertHoliday(model: HolidayModel): Observable<any> {
        var insertModel = this.convertHolidayModelToHolidayInsertModel(model);
        let formattedModel: JSON = this.formatInsertModel(insertModel);
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'InsertHoliday', formattedModel).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    deleteHoliday(holidayModel: HolidayModel): Observable<any> {
        var deleteModel = this.convertHolidayModelToHolidayDeleteModel(holidayModel);
        let formattedModel: JSON = this.formatDeleteModel(deleteModel);
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'DeleteHoliday', formattedModel).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    formatUpdateModel(updateModel: HolidayUpdateModel): any {
        return {
            holidayKey: updateModel.holidayKey,
            clientKey: updateModel.clientKey,
            holidayDate: updateModel.holidayDate,
            holiday: updateModel.holiday,
            isDeleted: updateModel.isDeleted ? updateModel.isDeleted : false,
            lastMod: updateModel.lastMod,
            lastModUserKey: updateModel.lastModUserKey ? updateModel.lastModUserKey : null,
            nbrOfHours: updateModel.nbrOfHours,
        };
    }

    formatInsertModel(updateModel: HolidayInsertModel): any {
        return {
            holiday: updateModel.holiday ? updateModel.holiday : null,
            clientKey: updateModel.clientKey,
            holidayDate: updateModel.holidayDate,
            isDeleted: updateModel.isDeleted ? updateModel.isDeleted : false,
            lastMod: updateModel.lastMod,
            lastModUserKey: updateModel.lastModUserKey ? updateModel.lastModUserKey : null,
            nbrOfHours: updateModel.nbrOfHours,
        };
    }

    formatDeleteModel(updateModel: HolidayDeleteModel): any {
        return {
            holidayKey: updateModel.holidayKey,
            clientKey: updateModel.clientKey,
            userKey: updateModel.userKey,
        };
    }

    convertHolidayModelToHolidayUpdateModel(model: HolidayModel): HolidayUpdateModel {
        var updateModel: HolidayUpdateModel = {
            holidayKey: model.holidayKey,
            clientKey: model.clientKey,
            holidayDate: model.holidayDate,
            holiday: model.holiday,
            isDeleted: model.isDeleted,
            lastMod: model.lastMod,
            lastModUserKey: model.lastModUserKey,
            nbrOfHours: model.nbrOfHours,
        };
        return updateModel;
    }

    convertHolidayModelToHolidayInsertModel(model: HolidayModel): HolidayInsertModel {
        var insertModel: HolidayInsertModel = {
            clientKey: model.clientKey,
            holidayDate: model.holidayDate,
            holiday: model.holiday ? model.holiday : null,
            isDeleted: model.isDeleted ? model.isDeleted : false,
            lastMod: model.lastMod ? model.lastMod : new Date(),
            lastModUserKey: model.lastModUserKey ? model.lastModUserKey : null,
            nbrOfHours: model.nbrOfHours,
        };
        return insertModel;
    }

    convertHolidayModelToHolidayDeleteModel(model: HolidayModel): HolidayDeleteModel {
        var deleteModel: HolidayDeleteModel = {
            holidayKey: model.holidayKey,
            clientKey: model.clientKey,
            userKey: model.lastModUserKey,
        };
        return deleteModel;
    }
}
